import jcf from 'jcf/js/jcf'

// import 'jcf/js/jcf.button'
// import 'jcf/js/jcf.checkbox'
// import 'jcf/js/jcf.file'
// import 'jcf/js/jcf.number'
// import 'jcf/js/jcf.radio'
import 'jcf/js/jcf.range'
// import 'jcf/js/jcf.scrollable'
import 'jcf/js/jcf.select'
// import 'jcf/js/jcf.textarea'

export default jcf;

jcf.setOptions('Select', {
  wrapNative: false,
  wrapNativeOnMobile: true,
  fakeDropInBody: false,
  maxVisibleItems: 14,
});

jcf.setOptions('Range', {
  minRange: 10,
});

// Override the select and inject our subtitles (if applicable)
const selectProto = jcf.modules.Select.prototype.plugins.SelectList.prototype;
const init = selectProto.init;
const createOption = selectProto.createOption;
selectProto.init = function() {
  init.apply(this, arguments);
  this.options.multipleSelectWithoutKey = true;
}
selectProto.createOption = function(option) {
  // Build the element using the built in function
  const newOption = createOption.apply(this, arguments);
  const image = option.getAttribute('data-image');

  if (image) {
    newOption.innerHTML = `<img src="${image}">
    <div>
      <span>${newOption.innerText}</span>
    </div>`;
    newOption.classList.add('has-image');
  }

  return newOption;
}

const rangeProto = jcf.modules.Range.prototype;
const onHandleMove = rangeProto.onHandleMove;
const initStructure = rangeProto.initStructure;
const getDragHandleRange = rangeProto.getDragHandleRange;
const refresh = rangeProto.refresh;
$.extend(rangeProto, {
  onHandleMove: function(e) {
    // Run the original handler first to ensure all values have been calculated
    onHandleMove.apply(this, arguments);

    this.updateLabels()
  },

  refresh: function() {
    refresh.apply(this, arguments);

    this.updateLabels()
  },

  updateLabels: function() {
    this.values.map((value, i) => {
      if (parseInt(value) === this.maxValue) value = `${value}+`
      this.valueLabels[i].innerText = value
    })
  },

  initStructure: function() {
    // Run the original handler first to ensure default structure has been generated
    initStructure.apply(this, arguments);

    this.valueLabels = [];
    this.fakeElement.map((i, element) => {
      const valueLabelWrapper = document.createElement('div')
      const firstChild = element.children.length ? element.children[0] : null
      valueLabelWrapper.className = 'range-label-wrapper'
      if (firstChild) {
        element.insertBefore(valueLabelWrapper, firstChild)
      } else {
        element.append(valueLabelWrapper)
      }

      this.values.map(value => {
        const label = document.createElement('label')
        label.className = 'range-label'
        valueLabelWrapper.appendChild(label)

        this.valueLabels.push(label)
      })
    })

    this.updateLabels()
    this.setupStep()
  },

  setupStep: function() {
    const range = this.maxValue - this.minValue;

    this.stepValue = 50; // Fixed $50 increments for better precision at low price ranges
    this.minRange = 5; // Allow minimum $5 gap between handles to enable filtering by 20, 50, 100
    this.stepsCount = Math.floor((this.maxValue - this.minValue) / this.stepValue);
  },

  getDragHandleRange: function() {
    const range = getDragHandleRange.apply(this, arguments);

    return {
      minStepIndex: Math.ceil(range.minStepIndex),
      maxStepIndex: Math.floor(range.maxStepIndex),
    }
  }
});

const roundToNearest = (value, target) => {
  return Math.ceil(value / target) * target;
}

export const clearRange = (element) => {
  if (element) {
    const instance = jcf.getInstance(element);
    const values = [
      element.getAttribute('min'),
      element.getAttribute('max'),
    ].map(i => parseInt(i));
    element.value = values[0];

    if (instance) {
      instance.values = values;
      instance.setSliderValue(values);
      instance.refresh();
    }
  }
}

// Fix dropdown stacking by adjusting z-index on active dropdown container
// This can't be done in CSS, because two "sibling" dropdowns can't be both in front of each other simultaneously
// Therefore we need to make only the active dropdown have an increased z-index.
export const applyJcfDropdownZIndexFix = () => {
  const dropdownGroups = document.querySelectorAll('.umbraco-forms-field.dropdown');

  dropdownGroups.forEach(elem => {
    elem.addEventListener('click', function () {
      dropdownGroups.forEach(e => {
        e.style.zIndex = '1';
      });

      //console.log("Set index of element to 10", this); // Uncomment to test this functionality
      this.style.zIndex = '10';
    });
  });
};
